import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledThumbContainer,
  StyledThumbContainerHeader,
  StyledThumbContainerFooter
} from './ThumbContainer.styles'

import {
  THUMBCONTAINER_VARIANT_DEFAULT,
  THUMBCONTAINER_VARIANT_SMALL
} from './constants'

export const ThumbContainer = ({
  children,
  className,
  'data-mu-test': dataAttributeTest,
  variant
}) => {
  return (
    <StyledThumbContainer
      className={className}
      data-mu-test={dataAttributeTest}
      $variant={variant}
    >
      {children}
    </StyledThumbContainer>
  )
}

ThumbContainer.defaultProps = {
  variant: THUMBCONTAINER_VARIANT_DEFAULT
}

ThumbContainer.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  children: PropTypes.node,
  variant: PropTypes.oneOf([
    THUMBCONTAINER_VARIANT_DEFAULT,
    THUMBCONTAINER_VARIANT_SMALL
  ])
}

export const ThumbContainerHeader = ({
  children,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <StyledThumbContainerHeader
      className={className}
      data-mu-test={dataAttributeTest}
    >
      {children}
    </StyledThumbContainerHeader>
  )
}

ThumbContainerHeader.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  children: PropTypes.node
}

export const ThumbContainerFooter = ({
  children,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <StyledThumbContainerFooter
      className={className}
      data-mu-test={dataAttributeTest}
    >
      {children}
    </StyledThumbContainerFooter>
  )
}

ThumbContainerFooter.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  children: PropTypes.node
}
